import { useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { routeList } from "../App";
import { lang } from "../assets/languages/en.language";
import DogNameCurved from "../components/DogNameCurved.component";
import { TertiaryRoundBigTextCta } from "../styles/Button.style";
import { RootContainer } from "../styles/Container.style";
import { StandardImage } from "../styles/Image.style";
import { Column, Gap } from "../styles/Utils";

export default function StaffMatchHappeningPage() {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <RootContainer $background={theme.color.primary} $topSafe={true}>
      <Column>
        <ImgaeContainer>
          <div>
            <DogNameCurved
              dogName={lang.matchHappeningPage.label1}
              color={theme.color.tertiary}
              textShadow={theme.font.elevation.big}
            />
          </div>
          <StandardImage src="/pictures/staff-profile.jpg" />
          <div>
            <DogNameCurved
              dogName={lang.matchHappeningPage.label2}
              color={theme.color.tertiary}
              textShadow={theme.font.elevation.big}
            />
          </div>
        </ImgaeContainer>
        <BigTitle $color={theme.color.tertiaryLight} $fontSize={theme.font.size.title.big} $textAlign="center">
          {lang.staffMatchHappeingPage.text1}
        </BigTitle>
        <Gap $height={3} />
        <TertiaryRoundBigTextCta onClick={() => navigate(routeList.chat)}>
          {lang.buttons.continue}
        </TertiaryRoundBigTextCta>
      </Column>
    </RootContainer>
  );
}

export const BigTitle = styled.span<{ $fontSize?: string; $color?: string; $textAlign?: string }>`
  color: ${(props) => props.$color ?? props.theme.color.primary};
  font-size: ${(props) => props.$fontSize ?? props.theme.font.size.title.xxbig};
  font-family: ${(props) => props.theme.font.family.title};
  text-align: ${(props) => props.$textAlign};
`;

const ImgaeContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1.2;
  margin-bottom: 5%; // Important to not crop the bottom of the curves dog name. Later Make the dogname text fit in the viewport.
  > img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  > div {
    position: absolute;
    width: 100%;
    z-index: 2;
  }
  div:first-of-type {
    top: 0%;
  }
  div:last-of-type {
    bottom: 0%;
  }
`;
